import React from "react";
import { useHostAdapter } from "../../platform";
import CheckOutActions from "../../features/checkout/components/CheckOutActions";
import PaneHeader from "./PaneHeader";
import HeaderMenu from "./HeaderMenu";
import { cn } from "../../lib/utils";

type MainLayoutProps = {
  children: React.ReactNode;
  /** The mode switch, at the left of the row under the header. */
  modeBar?: React.ReactNode;
  /**
   * What sits at the right of that row: Draft's New chat, Assembly's save button. It
   * used to default to the open document's file name, which repeated the application's
   * own title bar and was dropped.
   */
  modeBarEnd?: React.ReactNode;
  /**
   * Actions for a host whose header is not Save and Check in -- Outlook's File. They sit
   * where those do, before the overflow menu.
   */
  headerActions?: React.ReactNode;
};

const Mainlayout = ({ children, modeBar, modeBarEnd, headerActions }: MainLayoutProps) => {
  const host = useHostAdapter();

  return (
    <div className="flex h-screen flex-col overflow-hidden">
      <PaneHeader>
        {/* Save and Check in belong to the document, not to whichever mode is showing,
            so they live here rather than being passed in by each one. Only where the
            host has a document to save: Outlook has none, so its header carries neither
            -- absent rather than present-and-disabled, because there is nothing to
            explain. It passes its own File action instead. */}
        {host.documents && <CheckOutActions documents={host.documents} />}
        {headerActions}
        <HeaderMenu />
      </PaneHeader>

      {/* The row under the header exists only when it has something to say. Excel and
          PowerPoint have one mode and so no switch, but Draft's New chat still needs it;
          Outlook has neither and gets no row at all -- OpenMessageBar does that job there. */}
      {(modeBar || modeBarEnd) && (
        <div className="flex min-w-0 flex-none flex-row items-center justify-between gap-2 px-3.5 pt-2.5">
          <div className={cn("flex min-w-0 items-center", modeBar ? "flex-none" : "flex-1")}>
            {modeBar}
          </div>
          <div className="flex min-w-0 items-center justify-end">{modeBarEnd}</div>
        </div>
      )}

      <div className="min-h-0 flex-1 overflow-hidden">{children}</div>
    </div>
  );
};

export default Mainlayout;
